import React from 'react';
import Udesk from 'Udesk';
import { Badge } from 'udesk-ui';
import ImageViewer from 'src/components/common/ImageViewer';
import './index.less';

export const Cover = React.memo((props: { src: string; courseType?: number; isPad?: boolean }) => {
    const courseType = Udesk.enums.lessonType.find((t) => t.id === props.courseType);
    return courseType ? (
        <Badge.Ribbon text={courseType.name} color={courseType.color} placement="start">
            <ImageViewer>
                <img
                    className={'udesk-qa-coach-cover-image'}
                    width={props.isPad ? 150 : 250}
                    height={150}
                    // placeholder={true}
                    src={props.src || '/static/images/course-cover.png'}
                    alt=""
                />
            </ImageViewer>
        </Badge.Ribbon>
    ) : (
        <ImageViewer>
            <img
                className={'udesk-qa-coach-cover-image'}
                width={props.isPad ? 150 : 250}
                height={150}
                // placeholder={true}
                src={props.src || '/static/images/course-cover.png'}
                alt=""
            />
        </ImageViewer>
    );
});
